import moment from 'moment'
import Import from '../../../../images/Import.png'
import {ProfitabilityContext} from '../../context'
import {useContext, useState} from 'react'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import {dataToCustomerGroupReportCSV} from '../../utils'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'

const CustomerGroupTableHeader = () => {
  const [isLoading, setIsLoading] = useState(false)
  const {
    CustomersGroupsData,
    onChangeCustomerGroupCustomersGroupsFilter,
    customerGroups,
    isCustomerGroupsLoading,
  } = useContext(ProfitabilityContext)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToCustomerGroupReportCSV(CustomersGroupsData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Profitability_Customer_Group_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex justify-content-between align-items-center mb-10'>
      <h2 className='text-dark fw-bolder'>Customer Group</h2>
      <div className='d-flex align-items-end gap-5'>
        <MultiSelect
          id={`customer-group-filter`}
          label='Customer Group'
          options={customerGroups}
          className='w-200px'
          placeholder='Select Customer Group'
          allValuesSelectedText={'Customer Group: All'}
          isLoading={isCustomerGroupsLoading}
          handleSelected={onChangeCustomerGroupCustomersGroupsFilter}
        />
        <button
          className='btn btn-outline'
          onClick={handleDownLoadCSV}
          disabled={isLoading || !CustomersGroupsData?.length}
        >
          <div className='d-flex align-items-center'>
            <img src={Import} alt='Import File' className='me-2 import-icon' />
            <div className='d-flex align-items-center'>
              {isLoading ? 'Downloading...' : 'Export CSV'}
              {isLoading && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default CustomerGroupTableHeader
